// @LTG-ID: F-019
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-019, source Landing Page.html lines 2830-2853
// @CHANGED: 2026-02 session_003 (CHG-0048)
// @OWNER: web
//
// F-019 — 7 short-form purchase FAQs. Single-expanded; initial open = 0 per
// source. Q/01..Q/07 numbering with Geist Mono.

import { useState } from "react";
import { FAQ } from "../../data/faq";
import ItalicPeriod from "../brand/ItalicPeriod";
import "./faq.css";

export function Faq() {
    const [open, setOpen] = useState(0);

    return (
        <section
            className="ltg-faq-section"
            id="faq"
            data-testid="faq-section"
        >
            <div className="ltg-narrow">
                <div className="ltg-block-head">
                    <span
                        className="ltg-eyebrow"
                        data-testid="faq-eyebrow"
                    >
                        Frequently asked
                    </span>
                    <h2 data-testid="faq-h2">
                        What owners ask before they buy
                        <ItalicPeriod />
                    </h2>
                </div>
                <div className="ltg-faq__list" data-testid="faq-list">
                    {FAQ.map((item, i) => {
                        const isOpen = open === i;
                        return (
                            <div
                                key={item.q}
                                className={
                                    "ltg-faq__item" +
                                    (isOpen ? " ltg-faq__item--open" : "")
                                }
                                data-testid={`faq-item-${i}`}
                            >
                                <button
                                    type="button"
                                    className="ltg-faq__trigger"
                                    onClick={() => setOpen(isOpen ? -1 : i)}
                                    aria-expanded={isOpen}
                                    aria-controls={`faq-answer-${i}`}
                                    data-testid={`faq-trigger-${i}`}
                                >
                                    <span className="ltg-faq__num">
                                        Q/{String(i + 1).padStart(2, "0")}
                                    </span>
                                    <span className="ltg-faq__text">
                                        {item.q}
                                    </span>
                                    <span
                                        className="ltg-faq__icon"
                                        aria-hidden="true"
                                    >
                                        {isOpen ? "–" : "+"}
                                    </span>
                                </button>
                                {isOpen && (
                                    <div
                                        id={`faq-answer-${i}`}
                                        className="ltg-faq__a"
                                        data-testid={`faq-answer-${i}`}
                                    >
                                        {item.a}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

export default Faq;
